import { Box, Flex, Text } from '@chakra-ui/react';
import TreasuryAmount from './TreasuryAmount';
import s from './TreasuryDetail.module.scss';
import TreasuryProposal from './TreasuryProposal';

type Props = {
  show: boolean;
  onClose: () => void;
  defaultTab?: number;
  feeInfo?: any;
  profile?: any;
};

const TreasuryDetail = ({ show, onClose, feeInfo, profile }: Props) => {
  if (!show) return <></>;

  return (
    <div className={s.wrapper}>
      <div className={s.heading}>
        <div className={s.backIcon} onClick={onClose}>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
          >
            <path
              d="M14.4001 16.7998L9.6001 11.9998L14.4001 7.19981"
              stroke="white"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        </div>
        <Flex direction={'column'} className={s.title}>
          <Box className={s.name}>{profile?.twitterName} Treasury</Box>
          {/*<Box className={s.textTitle}>Community Treasury</Box>*/}
        </Flex>
      </div>
      <Text fontSize={'15px'} fontWeight={'500'} p={'0 16px'}>
        {profile?.twitterName} key holders govern {profile?.twitterName}{' '}
        treasury, enabling them to vote on proposals. A minimum of 1{' '}
        {profile?.twitterName} key is required to submit proposals.
      </Text>
      <TreasuryAmount profile={profile} feeInfo={feeInfo} />
      <TreasuryProposal profile={profile} />
    </div>
  );
};

export default TreasuryDetail;
